import { FC, ReactElement } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@razorpay/blade/components';
import { RazorPayLogo } from '@components/svg-icons';
import AppSideNav from '@src/layout/SideNav';
import { SideNavProvider, useSideNav } from '@src/context/SideNavContext';
import { useAuth } from '@hooks/useAuth';
import { SIDENAV_WIDTHS } from '@constants/sidenavConfig';

const LayoutContent: FC = (): ReactElement => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const showSideNav = isAuthenticated && !isLoginPage;
  const { isCollapsed } = useSideNav();

  // Margin adjusts based on sidebar collapse state
  const sidenavMargin = isCollapsed
    ? SIDENAV_WIDTHS.collapsed
    : SIDENAV_WIDTHS.expanded;

  return (
    <div className="relative flex h-screen w-full">
      {showSideNav ? <AppSideNav /> : null}

      <Box
        as="main"
        flex="1"
        overflowY="auto"
        marginLeft={
          showSideNav ? { base: 'spacing.0', m: sidenavMargin } : 'spacing.0'
        }
        height="100vh"
        transition="margin-left 0.3s ease"
        backgroundColor="surface.background.gray.subtle"
      >
        <Outlet />
      </Box>

      <div className="fixed bottom-4 right-4 flex items-center gap-1 rounded bg-white/80 px-2 py-1 shadow">
        <span className="text-sm text-gray-600">Powered by</span>
        <RazorPayLogo />
      </div>
    </div>
  );
};

const Layout: FC = (): ReactElement => {
  return (
    <SideNavProvider>
      <LayoutContent />
    </SideNavProvider>
  );
};

export default Layout;
